import { NetmisUserRoleDto } from "../../roles/dtos/NetmisUserRoleDto";

export class RemoveProviderRoleFormDto {
  providerId: string;
  constructor(dto?: NetmisUserRoleDto) {
    this.providerId = dto?.provider?.id || "";
  }
}
